import { FC } from "react"

import { Stack, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import {
  IGroupImportIssue,
  IGroupImportIssueReason,
  IGroupScope,
} from "ts/interfaces/Group"

interface IImportIssuesListProps {
  titleKey: string
  issues: IGroupImportIssue[]
  scope: IGroupScope
}

const importIssueReasonKey: Record<
  IGroupScope,
  Record<IGroupImportIssueReason, string>
> = {
  CLASS: {
    missing_identifier: "group.importReasonMissingIdentifier",
    group_name_too_long: "group.importReasonGroupNameTooLong",
    student_not_found: "group.importReasonStudentNotFound",
  },
  SCHOOL: {
    missing_identifier: "group.importReasonMissingIdentifier",
    group_name_too_long: "group.importReasonGroupNameTooLong",
    student_not_found: "group.importReasonStudentNotFoundSchool",
  },
}

const ImportIssuesList: FC<IImportIssuesListProps> = ({
  titleKey,
  issues,
  scope,
}) => {
  const { t } = useTranslation()

  if (issues.length === 0) return null

  return (
    <Stack gap="4px">
      <Typography variant="body1" fontWeight="500" color="mockup.neutral0">
        {t(titleKey)}
      </Typography>
      <Stack gap="4px" color="mockup.error50">
        {issues.map((issue, index) => {
          const line = `${t("group.importIssueLine", {
            row: issue.row,
            column: issue.column,
          })} - ${t(importIssueReasonKey[scope][issue.reason])}${
            issue.value ? ` ("${issue.value}")` : ""
          }`
          return (
            <Typography variant="body2" key={`${issue.row}-${index}`}>
              {line}
            </Typography>
          )
        })}
      </Stack>
    </Stack>
  )
}

export default ImportIssuesList
